// extracted by mini-css-extract-plugin
module.exports = {"post":"Post_post__4oGDa","postHead":"Post_postHead__6SFEZ","postBody":"Post_postBody__cynBm","demo-editor":"Post_demo-editor__lh6E2"};